import { createReducer } from '@reduxjs/toolkit';
import { set_discount } from '../confg';

// const initialDiscountState = JSON.parse(localStorage.getItem('discount')) || '';
const initialDiscountState = '';

const discount = createReducer(initialDiscountState, {
  [set_discount]: (state, action) => {
    const newDiscount = action.payload;
    // localStorage.setItem('discount', JSON.stringify(newDiscount)); // Persist to localStorage
    return newDiscount;
  }
});

export default discount;
